import React from "react";
import Marquee from "../components/Marquee";

const citations = [
  {
    num: 1,
    text: 'National Association of Manufacturers. "Cost of Federal Regulation to the U.S. Economy, Manufacturing, and Small Business." National Association of Manufacturers, 2023, www.nam.org/issues/regulatory-policy.',
    pages: "Businesses (Artifact 01)",
  },
  {
    num: 2,
    text: 'U.S. Energy Information Administration. "U.S. Coal Power Plant Retirements, 2010–2022." U.S. Department of Energy, 2022, www.eia.gov/coal/annual.',
    pages: "Businesses (Artifact 02)",
  },
  {
    num: 3,
    text: 'U.S. Congress. "Dodd-Frank Wall Street Reform and Consumer Protection Act." Public Law 111-203, 124 Stat. 1376, 2010, www.congress.gov/111/plaws/publ203/PLAW-111publ203.pdf.',
    pages: "Businesses (Artifact 03)",
  },
  {
    num: 4,
    text: 'Bureau of Labor Statistics. "National Census of Fatal Occupational Injuries in 2022." U.S. Department of Labor, 19 Dec. 2023, www.bls.gov/news.release/cfoi.nr0.htm.',
    pages: "Workers (Artifact 01)",
  },
  {
    num: 5,
    text: 'Congressional Budget Office. "The Effects on Employment and Family Income of Increasing the Federal Minimum Wage." CBO, July 2019, www.cbo.gov/publication/55071.',
    pages: "Workers (Artifact 02)",
  },
  {
    num: 6,
    text: 'U.S. Department of Labor. "Family and Medical Leave Act." Wage and Hour Division, 2023, www.dol.gov/agencies/whd/fmla.',
    pages: "Workers (Artifact 03)",
  },
  {
    num: 7,
    text: 'U.S. Food and Drug Administration. "Drug Approval Process." FDA, 2023, www.fda.gov/patients/learn-about-drug-and-device-approvals/drug-approval-process.',
    pages: "Consumers (Artifact 01)",
  },
  {
    num: 8,
    text: 'Federal Trade Commission. "Antitrust Laws and You." FTC, 2023, www.ftc.gov/tips-advice/competition-guidance/guide-antitrust-laws.',
    pages: "Consumers (Artifact 02)",
  },
  {
    num: 9,
    text: 'Consumer Financial Protection Bureau. "CFPB by the Numbers." CFPB, 2022, www.consumerfinance.gov/about-us/the-bureau/cfpb-by-the-numbers.',
    pages: "Consumers (Artifact 03)",
  },
  {
    num: 10,
    text: 'Environmental Protection Agency. "Benefits and Costs of the Clean Air Act, 1990–2020." EPA, 2022, www.epa.gov/clean-air-act-overview/benefits-and-costs-clean-air-act.',
    pages: "Businesses (Artifact 02) — Additional",
  },
  {
    num: 11,
    text: 'Occupational Safety and Health Administration. "OSHA\'s 50th Anniversary: Worker Safety and Health." U.S. Department of Labor, 2020, www.osha.gov/osha50.',
    pages: "Workers (Artifact 01) — Additional",
  },
  {
    num: 12,
    text: 'Small Business Administration. "The Cost of Federal Regulation to the U.S. Economy, Manufacturing and Small Business." SBA Office of Advocacy, 2023, advocacy.sba.gov/issues/regulations.',
    pages: "Businesses (Artifact 01) — Additional",
  },
];

export default function Citations() {
  return (
    <div style={{ backgroundColor: "#050505", paddingTop: "64px" }}>
      {/* Header */}
      <div
        data-testid="citations-header"
        style={{
          padding: "64px 24px 56px",
          borderBottom: "1px solid #1A1A1A",
          backgroundColor: "#0A0A0A",
        }}
      >
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <p
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#A1A1AA",
              marginBottom: "16px",
            }}
          >
            Page 06 — Works Cited
          </p>
          <h1
            style={{
              fontFamily: "'Cabinet Grotesk', sans-serif",
              fontSize: "clamp(2rem, 5vw, 3.8rem)",
              fontWeight: 900,
              letterSpacing: "-0.03em",
              color: "#FFFFFF",
              marginBottom: "16px",
              lineHeight: 1.05,
            }}
          >
            MLA Works Cited
          </h1>
          <p
            style={{
              fontSize: "16px",
              color: "#71717A",
              maxWidth: "680px",
              lineHeight: 1.65,
            }}
          >
            All sources used in this project, formatted in MLA 9th edition.
            Citations are numbered in the order they first appear across the
            project's evidence pages.
          </p>
        </div>
      </div>

      <Marquee />

      {/* Citation List */}
      <div
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          padding: "64px 24px 96px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            marginBottom: "48px",
            paddingBottom: "20px",
            borderBottom: "1px solid #1A1A1A",
          }}
        >
          <h2
            style={{
              fontFamily: "'Cabinet Grotesk', sans-serif",
              fontSize: "22px",
              fontWeight: 800,
              color: "#FFFFFF",
            }}
          >
            Works Cited
          </h2>
          <span
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.12em",
              color: "#52525B",
              paddingTop: "2px",
            }}
          >
            {citations.length} sources — MLA 9th Edition
          </span>
        </div>

        <div data-testid="citations-list">
          {citations.map((cite) => (
            <div
              key={cite.num}
              data-testid={`citation-${cite.num}`}
              style={{
                display: "grid",
                gridTemplateColumns: "40px 1fr",
                gap: "20px",
                marginBottom: "32px",
                paddingBottom: "32px",
                borderBottom: "1px solid #141414",
                alignItems: "start",
              }}
            >
              {/* Citation Number */}
              <span
                style={{
                  fontFamily: "'IBM Plex Mono', monospace",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#FF3B30",
                  paddingTop: "2px",
                }}
              >
                [{cite.num}]
              </span>

              {/* Citation Text */}
              <div>
                <p
                  className="mla-entry"
                  data-testid={`citation-text-${cite.num}`}
                  style={{
                    fontFamily: "'IBM Plex Sans', sans-serif",
                    fontSize: "14px",
                    lineHeight: 1.8,
                    color: "#D1D1D6",
                    paddingLeft: 0,
                    textIndent: 0,
                    marginBottom: "8px",
                  }}
                >
                  {cite.text}
                </p>
                <p
                  style={{
                    fontFamily: "'IBM Plex Mono', monospace",
                    fontSize: "10px",
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "#3F3F46",
                  }}
                >
                  Used on: {cite.pages}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* MLA Format Note */}
        <div
          data-testid="mla-format-note"
          style={{
            marginTop: "48px",
            padding: "28px 32px",
            backgroundColor: "#0D0D0D",
            border: "1px solid #1A1A1A",
            borderLeft: "3px solid #FFCC00",
          }}
        >
          <p
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "10px",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "#FFCC00",
              marginBottom: "12px",
            }}
          >
            MLA Format Note
          </p>
          <p style={{ color: "#71717A", fontSize: "13px", lineHeight: 1.75 }}>
            All citations follow MLA 9th Edition guidelines. Web sources
            include author (or organization name), title of page in quotation
            marks, website name in italics, publication/update date, and URL.
            In-text citations are indicated by superscript numbers (e.g.,{" "}
            <sup style={{ color: "#FF3B30" }}>[1]</sup>) throughout each
            evidence page, corresponding to the numbered sources in this Works
            Cited list.
          </p>
        </div>
      </div>
    </div>
  );
}
